<template>
  <div class="shakeBlindBox scroll-touch">
    <i class="shakeBlindBox_close" @click="$emit('close')"></i>
    <div class="shakeBlindBox_shake">
      <img
          class="shakeBlindBox_shake_img"
          src="~assets/img/icon/shake_icon.png"
          @click="elShake"
      />
      <span class="shakeBlindBox_shake_title" @click="elShake">点击晃一晃</span>
      <img
          id="shakeImg"
          v-lazy="detailData.openBoxImg"
          class="shakeBlindBox_shake_boximg"
          @click="elShake"
      />
      <i
          class="shakeBlindBox_shake_select"
          mg-stat-click
          mg-stat-custom="label=btn&cont=就选它&direct=cntp"
          mg-stat-mod="c_stargoodspop"
          @click="$emit('pay')"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detailData'],
  data() {
    return {
      shakeFlag: true,
    };
  },
  methods: {
    getStyle(obj, attr) {
      // 图片位置
      return obj.currentStyle
        ? obj.currentStyle[attr]
        : getComputedStyle(obj)[attr];
    },
    // 图片晃动
    elShake() {
      if (this.shakeFlag) {
        this.shakeFlag = false;
        const oImg = document.getElementById('shakeImg');
        // 先获取图片自身所在的left值
        const pos = parseFloat(this.getStyle(oImg, 'left'));
        let timer = null;
        let num = 0;
        const arr = [];
        const index = this.randomNum(8, 20);
        for (let i = index; i > 0; i -= 2) {
          arr.push(i, -i);
        }
        arr.push(0);
        // 启用定时器前先关闭定时器
        clearInterval(timer);
        timer = setInterval(() => {
          // 让图片的left跟随数组里的值变化就会实现左右移动效果
          oImg.style.left = `${pos + arr[num]}px`;
          num += 1;
          if (num === arr.length) {
            this.shakeFlag = true;
            clearInterval(timer);
          }
        }, 150);
      }
    },
    // 生成从minNum到maxNum的随机数
    randomNum(minNum, maxNum) {
      let result = 0;
      switch (arguments.length) {
        case 1:
          // eslint-disable-next-line no-mixed-operators
          result = parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          // eslint-disable-next-line no-mixed-operators
          result = parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          result = 0;
          break;
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.shakeBlindBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 3001;

  &_close {
    position: absolute;
    top: 120px;
    right: 44px;
    width: 44px;
    height: 44px;
    background: url("~assets/img/icon/close_box.png") no-repeat;
    background-size: cover;
  }

  &_shake {
    position: relative;

    &_img {
      position: absolute;
      left: 235px;
      top: 157px;
      width: 88px;
      height: 108px;
    }

    &_title {
      position: absolute;
      top: 194px;
      left: 326px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 48px;
    }

    &_boximg {
      position: absolute;
      top: 327px;
      left: 159px;
      width: 430px;
      height: 580px;
    }

    &_select {
      position: absolute;
      left: 253px;
      top: 989px;
      width: 242px;
      height: 96px;
      background: url("~assets/img/activity/select_it.png") no-repeat;
      background-size: cover;
    }
  }
}
</style>
